import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import { compose } from 'recompose';
import withStyles from 'react-jss';
import { Grid } from 'semantic-ui-react';

import { ClassProp, WithRouterProps } from 'helpers/types';

import Demographics from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/sections/Demographics';
import QuickLook from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/sections/QuickLook';
import KeyMetricGraphs from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/sections/KeyMetricGraphs';
import { MerchantOverviewProvider } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/MerchantOverview.context';
import TopMetros from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOverview/sections/ConsumerActivity/components/TopMetros';

type Props = WithRouterProps & {
  classes: ClassProp<typeof styles>;
};

const styles = {
  container: {
    width: '100%',
    marginTop: '2.25rem !important',
    justifyContent: 'center !important',
  },
  keyMetricGraphsExternal: {
    marginTop: '5rem !important',
  },
  quickLook: {
    marginBottom: '0.9285625rem',
  },
  topMetrosSection: {
    marginTop: '2rem !important',
  },
  topMetros: {
    padding: '0 !important',
  },
};

const Tier3Overview: FunctionComponent<Props> = ({
  classes,
  match,
  location,
}) => {
  const [topVenuesRef, topVenuesInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [demographicsRef, demographicsInView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <MerchantOverviewProvider location={location}>
      <div className={classes.container}>
        <div className={classes.quickLook}>
          <QuickLook match={match} locked />
        </div>

        <div className={classes.keyMetricGraphsExternal}>
          <KeyMetricGraphs match={match} />
        </div>

        <div ref={topVenuesRef}>
          {topVenuesInView && (
            <Grid>
              <Grid.Row className={classes.topMetrosSection}>
                <Grid.Column className={classes.topMetros}>
                  <TopMetros
                    match={match}
                    title="Top Venues"
                    userType="tier3"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )}
        </div>

        <div ref={demographicsRef}>
          {demographicsInView && <Demographics match={match} />}
        </div>
      </div>
    </MerchantOverviewProvider>
  );
};

export default compose<Props, any>(
  withRouter,
  withStyles(styles as any),
)(Tier3Overview);
